import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { stocksClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query StockItems($page: Int, $limit: Int, $search: String, $sort: StockItemSort) {
    stockItems(page: $page, limit: $limit, search: $search, sort: $sort) {
      id
      name
    }
  }
`

export const useStockItemsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: stocksClient })
  return (search, page = 1) => {
    return query({ search, page, filter, sort: { field: 'NAME', type: 'ASC' } })?.then(
      pathOr([], ['data', 'stockItems'])
    )
  }
}

const StockItemSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useStockItemsLoader(filter)
  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default StockItemSelect
